import { Star, ArrowUpRight } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "./ui/carousel";
import { Reveal } from "./Reveal";
import { SITE, REVIEWS } from "../data/site";

export const Reviews = ({ embedded = false }) => {
  const body = (
    <>
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-amber-400">
            Google Reviews
          </p>
          <h3 className="mt-3 font-display text-2xl font-medium tracking-tight text-cream sm:text-3xl">
            Loved by Vijayawada
          </h3>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-fog">
            Straight from our Google Business profile — swipe through what customers say.
          </p>
        </div>
        <a
          href={SITE.reviewUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="write-review-link"
          className="group inline-flex items-center justify-center gap-2 rounded-full border border-white/15 px-6 py-3 text-sm font-medium text-cream transition-all duration-300 hover:border-amber-400/60 hover:text-amber-400"
        >
          Write us a review
          <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
      <div className="mt-10">
        <Carousel opts={{ align: "start", loop: true }} className="w-full">
          <CarouselContent className="-ml-4">
            {REVIEWS.map((r, i) => (
              <CarouselItem key={r.name} className="pl-4 sm:basis-1/2 lg:basis-1/3">
                <div
                  className="flex h-full flex-col rounded-3xl border border-white/10 bg-obsidian/60 p-7 transition-colors duration-500 hover:border-amber-400/40"
                  data-testid={`review-card-${i}`}
                >
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={14} className="fill-amber-400 text-amber-400" />
                    ))}
                  </div>
                  <p className="mt-4 flex-1 text-sm leading-relaxed text-fog">“{r.text}”</p>
                  <div className="mt-6 flex items-center justify-between border-t border-white/5 pt-4">
                    <p className="font-display text-base font-medium text-cream">{r.name}</p>
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ash">
                      Google review
                    </p>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="mt-8 hidden gap-3 sm:flex">
            <CarouselPrevious
              data-testid="reviews-prev-button"
              className="static translate-y-0 border-white/15 bg-transparent text-cream hover:border-amber-400/60 hover:bg-transparent hover:text-amber-400"
            />
            <CarouselNext
              data-testid="reviews-next-button"
              className="static translate-y-0 border-white/15 bg-transparent text-cream hover:border-amber-400/60 hover:bg-transparent hover:text-amber-400"
            />
          </div>
        </Carousel>
      </div>
    </>
  );

  if (embedded) {
    return (
      <Reveal>
        <div
          className="rounded-3xl border border-amber-400/25 bg-amber-400/[0.04] p-4 sm:p-10"
          data-testid="reviews-section"
        >
          {body}
        </div>
      </Reveal>
    );
  }

  return (
    <section className="border-t border-white/10 py-24 sm:py-32" data-testid="reviews-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">{body}</div>
    </section>
  );
};
